<div class="container-box">
  <app-table-header tableTitle="Provvigione segnalatori" (btnUpdateClick)="loadCommissions()">
    <app-button-new-commission-signalman action-button></app-button-new-commission-signalman>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="commissionsSignalmanTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
